/**
 * Write all configuration options as parameters into the build
 */
import * as urlUtils from '../utils/urlUtils';


// resolved via webpack's EnvironmentPlugin
const analyticsUrl = process.env.JNEX_ANALYTICS_URL;
const auth2Uri = process.env.JNEX_AUTH_URI;
const backendUri = process.env.JNEX_BACKEND_URI;
const captchaSiteKey = process.env.JNEX_CAPTCHA_SITE_KEY;
const cdnUrl = process.env.JNEX_CDN_URL;
const environment = process.env.JNEX_ENVIRONMENT;
const pspClientId = process.env.JNEX_PAYMENT_PSP_CLIENT_ID;
const platformUri = process.env.JNEX_PLATFORM_URI;
const sentryDsn = process.env.SENTRY_CLIENT_WEB_DSN;
const sentryTracesSampleRateDefault = process.env.SENTRY_TRACES_SAMPLE_RATE_DEFAULT;

const isProductionEnvironment = environment === 'prod';
const isDevelopmentEnvironment = !isProductionEnvironment;
const isDevelopmentLocal = isDevelopmentEnvironment && window?.location?.hostname === 'localhost';

const analyticsDomain = urlUtils.extractHostname(platformUri);

export default {

    analytics: {
        apiHost: analyticsUrl,
        domain: analyticsDomain,
        isEnabled: !!analyticsUrl
    },


    auth: {
        clientId: 'jnex-client-web',
        realm: 'jnex',
        redirectUri: platformUri
    },


    calendly: {
        url: 'https://calendly.com/journexx/journexx-introduction-for-newspapers-and-magazines?month=2022-07'
    },


    captcha: {
        siteKey: captchaSiteKey
    },


    // Different endpoint configurations
    endpoints: {

        // auth server
        auth: {
            host: auth2Uri,
            path: '/auth'
        },

        // resource server/backend service
        backend: {
            host: backendUri,
            path: '/api'
        },

        // default backend to use if not explicitly provisioned during API request creation
        default: 'backend'
    },


    // environment
    environment: {
        name: environment,
        isDevelopment: isDevelopmentEnvironment,
        isDevelopmentLocal: isDevelopmentLocal,
        isProduction: isProductionEnvironment
    },


    host: {
        assetCdnUrl: cdnUrl,
        cdn: (() => {

            if (isProductionEnvironment) {

                return 'https://cdn.journexx.com';
            }

            return 'https://dev-cdn.journexx.com';
        })(),
        uri: platformUri
    },


    locale: {

        available: [
            {
                isBase: true,
                name: 'Deutsch',
                tag: 'de-DE'
            },
            {
                isBase: true,
                name: 'English GB',
                tag: 'en-GB'
            }/*,
            {
                isBase: true,
                name: 'French FR',
                tag: 'fr-FR'
            }*/
        ],

        // in case no locale could be detected from the user agent, ultimately end up with this locale
        defaultLanguageTag: 'en',
        defaultLocaleTag: 'en-GB'
    },


    payment: {
        paypal: {
            clientId: pspClientId
        }
    },


    sentry: {
        dsn: sentryDsn,
        environment: (() => {

            if (isDevelopmentLocal) {

                return 'dev-local';
            }

            return environment;
        })(),
        tracesSampleRate: sentryTracesSampleRateDefault
    },


    time: {

        timeZone: {

            // used in case no timezone id could be determined
            default: 'UTC'
        }
    }
};
